import React, { Component } from "react";
import { Popover, message, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import Render from "../../../components/Renderer";
//import context from '../../../utils/language'
import {
  getListSettingRegion,
  deleteRegion
} from "../../../redux/actions/setting";
import { isReadOnly } from "../../../utils/permission";
import { getRegion, getCountry } from "../../../redux/actions/dropdown";
import CustomTable from "../../../components/CustomTable";

class RegionNo extends Component {
  state = {
    form: {},
    data: [],
    visible: {},
    isLoading: false,
    filterCountry: []
  };

  componentDidMount() {
    setTimeout(() => {
      this.getList();
    }, 500);
    this.setCountry();
  }

  getList = param => {
    this.setState({ isLoading: true });
    this.props.getListSettingRegion(param).then(res => {
      this.setState({ isLoading: false });
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        let data = res.payload.data.data;
        data.sort((a, b) => a.countryName.localeCompare(b.countryName));
        let array = [];
        for (let [i, d] of data.entries()) {
          // let count = data.filter(x => x.countryId === d.countryId).length;
          // let span = 1;
          // if (count > 1) {
          //   const countExist = array.filter(x => x.countryId === d.countryId)
          //     .length;
          //   span = countExist === 0 ? count : 0;
          // }
          array.push({
            key: i,
            no: i + 1,
            regionId: d.regionId,
            regionNo: d.regionNo,
            countryId: d.countryId,
            countryName: d.countryName,
            dateUpdate: d.dateUpdate,
            nationality: d.countryCode,
            //rowSpan: span,
            descriptionEN: d.regionNameEN,
            descriptionTH: d.regionNameTH,
            display: d.isEnable === 1,
            updateDate: d.dateUpdate
          });
        }
        this.setState({ data: array });
      }
    });
  };

  setCountry = () => {
    this.props.getCountry().then(res => {
      if (res && res.payload.status === 200 && res.type.endsWith("SUCCESS")) {
        let data = res.payload.data.data;
        this.setState({
          filterCountry: data
        });
      }
    });
  };

  search = () => {
    let { form } = this.state;
    let param = null;
    param = "countryId=" + (form.country || "");
    this.getList(param);
  };

  onChange = ({ name, value }) => {
    let { form } = this.state;
    form[name] = value;
    this.setState({ form, data: [] }, this.search);
  };

  edit = item => this.props.onEdit(this.props.name, item);
  add = () => this.props.onAdd(this.props.name);

  onDelete = item => {
    let { visible } = this.state;
    visible[item.key] = false;
    this.setState({ visible, data: [] });
    this.props.deleteRegion(item.regionId).then(res => {
      if (res.status === 400) {
        message.error("ไม่สามารถลบข้อมูลได้");
      } else if (
        res &&
        res.payload.status === 200 &&
        res.type.endsWith("SUCCESS")
      ) {
        message.success("Delete Region success");
        this.props.getRegion();
      }
      this.search();
    });
  };

  refresh = () => {
    this.props.onRefreshDone();
    setTimeout(() => {
      this.search();
    }, 200);
  };

  visibleChange = item => {
    let { visible } = this.state;
    visible[item.key] = false;
    this.setState({ visible });
  };

  render() {
    const { form, data, isLoading, filterCountry } = this.state;
    const { refresh } = this.props;
    if (refresh) this.refresh();
    //const { language } = this.props
    const readOnly = isReadOnly("regionsetting");
    //const name = context[language].viewStatModal
    const columns = [
      {
        title: "#",
        key: "no",
        dataIndex: "no",
        width: 50
      },
      {
        title: "Country",
        key: "country",
        align: "center",
        width: 150,
        render: (value, row, index) => {
          const obj = {
            children: value.countryName
              ? value.countryName + " (" + value.nationality + ")"
              : "",
            props: {}
          };
          if (value.rowSpan !== undefined) obj.props.rowSpan = value.rowSpan;
          return obj;
        }
      },
      {
        title: "Region No.",
        dataIndex: "regionNo",
        key: "regionNo",
        align: "center",
        width: 150
      },
      {
        title: "Description (ENG)",
        dataIndex: "descriptionEN",
        key: "descriptionEN",
        width: 150
      },
      {
        title: "Description (TH)",
        dataIndex: "descriptionTH",
        key: "descriptionTH",
        width: 150
      },
      {
        title: "Update Date",
        dataIndex: "updateDate",
        key: "updateDate",
        width: 180
      },
      {
        title: "Edit",
        key: "edit",
        width: 80,
        render: item => (
          <button
            disabled={readOnly}
            onClick={() => this.edit(item)}
            type="button"
            className="btn btn-outline-success btn-sm"
          >
            <FontAwesomeIcon icon="pen" />
          </button>
        )
      },
      {
        title: "Delete",
        key: "delete",
        width: 80,
        render: item =>
          readOnly ? (
            <button
              disabled
              type="button"
              className="btn btn-outline-danger btn-sm"
            >
              <FontAwesomeIcon icon="trash" />
            </button>
          ) : (
            <Popover
              visible={this.state.visible[item.key]}
              onVisibleChange={_visible => {
                let { visible } = this.state;
                visible[item.key] = _visible;
                this.setState({ visible });
              }}
              content={
                <div className="col">
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm mr-2"
                    onClick={() => this.onDelete(item)}
                  >
                    Delete
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => this.visibleChange(item)}
                  >
                    Cancel
                  </button>
                </div>
              }
              title="Are you sure?"
              trigger="click"
            >
              <button
                disabled={readOnly}
                onClick={this.delete}
                type="button"
                className="btn btn-outline-danger btn-sm"
              >
                <FontAwesomeIcon icon="trash" />
              </button>
            </Popover>
          )
      }
    ];
    const sum = columns.reduce((a, b) => a + b.width, 0);
    const table = (
      <CustomTable
        pagination={false}
        bordered
        footer={
          isLoading
            ? () => (
                <div className="text-center">
                  <Spin className="pr-2" />
                  loading...
                </div>
              )
            : null
        }
        className="tbody-center bg-white"
        columns={columns}
        scroll={{ x: sum + "px" }}
        dataSource={data}
      />
    );

    const template = [
      {
        type: "select",
        name: "country",
        value: form.country,
        placeholder: "Select Country...",
        options: {
          name: "countryOptions",
          id: "countryId",
          text: "countryName",
          dataLoad: 1,
          dataService: filterCountry
        }
      }
    ];
    return (
      <div className="card card-body card-body-component">
        <div className="form-row form-inline col-md-12 mb-3 px-0">
          <div className="col-md-3">
            {!readOnly && (
              <button
                type="button"
                onClick={this.props.onNew}
                className="btn btn-success"
              >
                <FontAwesomeIcon icon="plus" /> Add Region No.
              </button>
            )}
          </div>
          <div className="col-md-9 form-inline justify-content-end px-0">
            {template.map((t, i) => (
              <div className="col-md-3 justify-content-end pr-0" key={i}>
                {Render(t, this.onChange)}
              </div>
            ))}
            <button
              onClick={() => this.setState({ form: {} }, this.search)}
              className="btn btn-sm btn-dark ml-2"
            >
              <FontAwesomeIcon icon="redo" />
              <span className="ml-2">clear</span>
            </button>
          </div>
        </div>
        {table}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  language: state.language
});

const mapDispatchToProps = dispatch => ({
  getListSettingRegion: param => dispatch(getListSettingRegion(param)),
  deleteRegion: id => dispatch(deleteRegion(id)),
  getRegion: () => dispatch(getRegion()),
  getCountry: () => dispatch(getCountry())
});

export default connect(mapStateToProps, mapDispatchToProps)(RegionNo);
